import React from "react";
import { relatedLinkBtnStyle } from "./relatedLinkLabels";

/**
 * Green pill link used on related-object cards. Shows a human label; ID goes in title tooltip.
 */
export default function RelatedObjectLink({ href, label, title, className }) {
  if (!href) {
    return <span style={{ fontWeight: 700 }}>{label || "—"}</span>;
  }

  return (
    <a
      href={href}
      className={`btn btn-sm btn-success ${className || ""}`.trim()}
      style={relatedLinkBtnStyle}
      title={title || undefined}
    >
      {label || "—"}
    </a>
  );
}
